module.exports = __webpack_public_path__ + "static/iconlabel-sentence-do-b70bed9410d73e3cc9fcb353318baa6e.png";